import { download} from "../../api/api"
import { Message } from "element-ui";
var downloadUtil={
    downloadFile:function(url,name){
        let fileNames=name
        let that = this;
        let paths=url.split(".")
        let houzhui=paths[paths.length-1]
        let _params={
          path:url
        }
        download(_params).then(datas=>{
          // debugger
          let _this=that
            const blob = new Blob([datas])
            const fileName ="";
            // if(houzhui==="docx"){
            //   _this.fileName = fileNames+'.docx'
            // }
            // if(houzhui=="doc"){
            //   _this.fileName = fileNames+'.doc'
            // }
            // if(houzhui==="xls"){
            //   _this.fileName = fileNames+'.xls'
            // }
            // if(houzhui==="pdf"){
            //   _this.fileName = fileNames+'.pdf'
            // }
            // if(houzhui==="jpg"||houzhui=="png"||houzhui=="jpeg"||houzhui=="webp"){
            //   _this.fileName = fileNames+'.png'
            // }
            _this.fileName=fileNames+ '.'+houzhui
            const dlink = document.createElement('a')
            if ('download' in document.createElement('a')) { // 非IE下载
              const dlink = document.createElement('a')
              dlink.download = _this.fileName
              dlink.style.display = 'none'
              dlink.href = URL.createObjectURL(blob)
              document.body.appendChild(dlink)
              dlink.click()
              URL.revokeObjectURL(dlink.href) // 释放URL 对象
              document.body.removeChild(dlink)
          } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
          }
        })
    
        // });
      
    },
    preview(url){
      console.log(url)
      var s = url.substring(url.lastIndexOf(".") + 1);
      console.log(s)
      if (s == "jpg" || s == "png" || s == "pdf" || s == "webp"||s == "JPG" || s == "PNG" || s == "pdf" || s == "WEBP") {
        window.open(
          url
        );
      } else if(s=="docx"){
        let _params={
          path:url
        }
        download(_params).then(datas=>{ 
          // debugger
          // let _this=that
            let blob = new Blob([datas],{type:s})
            let fileName = url.substring(url.lastIndexOf("/") + 1, url.length) // 得到文件名
            let docwindow = window.open("",'DetailRunTime'); // 创建新窗口
            let box = document.createElement('div')  // 创建一个div
            let docx = require("docx-preview")
            docx.renderAsync(blob,box)
            .then(() => {  
              // 渲染文件
              docwindow.document.write(box.outerHTML); 
              //渲染文件后将div添加到新窗口中，div不能提前添加，否则新窗口中不能渲染出文件
              //注意这里不能直接用box
              docwindow.document.title = fileName // 窗口标题
              // docwindow.document.getElementsByClassName('docx')[0]  .style.width = 'auto'
              // 如果文件显示正常，不用设置宽度，我的出现了下图所示只显示了一半
            })
        })
        // let res = await this.$API.common.preview.get({path}) // 获取到文件流
      }
      else {
        Message({
          message: "不支持该"+s+"文件格式预览",
          type: "error"
        });
      }
    }
    
}
export default downloadUtil



   


// WEBPACK FOOTER //
// ./src/components/downloads/download.js